export function useLoginRedirect() {
  const localStorageKey = 'tw__login_redirect';
  const ignoredPaths = [
    '/account/login',
    '/account/logout',
    '/account/external',
    '/account/forced-logout',
    '/expired',
    '/forbidden',
    '/unsupported-browser',
    '/unsupported-premiere-pro',
  ];

  function shouldStoreLocation(location) {
    if (!location || typeof location !== 'string') {
      return false;
    }

    try {
      const redirectUrl = new URL(location, window.location.origin);
      return !ignoredPaths.some((ignoredPath) => redirectUrl.pathname.startsWith(ignoredPath));
    } catch {
      return false;
    }
  }

  function setLocation(location) {
    if (!shouldStoreLocation(location)) {
      return;
    }

    window.localStorage.setItem(localStorageKey, location);
  }

  function getAndClearLocation() {
    const location = window.localStorage.getItem(localStorageKey);
    window.localStorage.removeItem(localStorageKey);
    return location;
  }

  return { setLocation, getAndClearLocation };
}
